import { MaskAccountNumberPipe } from '../../../../../_helpers/_pipes/mask-account-number.pipe';
import { BillingSidebarComponent } from '../billing-sidebar/billing-sidebar.component';
import { MapfreAlertComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { InformationIconSvgComponent } from '../../../../../modules/mapfre-design-library/src/lib/svg/information-icon-svg/information-icon-svg.component';
import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreLoadingComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { UserDetailsService } from './../../../../../_services/profile-settings/user-details.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Router, Params, ActivatedRoute , RouterModule } from '@angular/router';
import {
  AlertService,
  ModalOptions,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { BankAccountService } from '../../../../../_services/profile-settings/bank-account.service';
import { BillingDataService } from './../../../../../_services/data-services/billing-data.service';
import { BillingDetailsService } from './../../../../../_services/my-insurance/billing-details.service';
import { PolicyDataService } from './../../../../../_services/data-services/policy-data.service';
import { PolicyDetailsService } from '../../../../../_services/my-insurance/policy-details.service';
import { StorageServiceObservablesService } from '../../../../../_services/storage-service-observables/storage-service-observables.service';
import { ErrorRedirectionService } from '../../../../../_services/error-service/error-redirection.service';
import { Capacitor } from '@capacitor/core';
import { AppRatingService } from '../../../../../_services/pwa-service/app-rating.service';
import { Constants } from '@models/constants';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreModalComponent, InformationIconSvgComponent, MapfreButtonComponent, MapfreAlertComponent, BillingSidebarComponent, MaskAccountNumberPipe],
  selector: 'app-billing-confirm',
  templateUrl: './billing-confirm.component.html',
  styleUrls: ['./billing-confirm.component.scss'],
})
export class BillingConfirmComponent implements OnInit {
  billing: any;
  email: string;
  loading: boolean;
  policyId: string;
  policyDetails: any;
  user: any;
  storeBankAccount: string;
  loader = false;
  modalForMultiplePayment = false;
  paymentModal: ModalOptions;
  hideModalOnRoute: boolean;
  @Input() ach_policyId: string;
  @Input() achBilling: boolean;
  @Output() backToNewPayment = new EventEmitter();
  isAcmic: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    public alertService: AlertService,
    private bankAccountService: BankAccountService,
    private billingDataService: BillingDataService,
    private billingDetailsService: BillingDetailsService,
    private policyDataService: PolicyDataService,
    public router: Router,
    private storageService: StorageServiceObservablesService,
    private userDetailsService: UserDetailsService,
    private errorRedirectionService: ErrorRedirectionService,
    private acmicService: AcmicService,
    private policyDetailsService: PolicyDetailsService,
    private appRatingService: AppRatingService
  ) {
    this.email = this.storageService.getUserFromStorage();
    this.paymentModal = new ModalOptions({
      additionalClasses:
        'modal-small modal-dialog center-on-page confirm-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'paymentModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: 'CONFIRM_PAYMENT',
      modalName: 'billing_Confirm_Payment',
    });

    this.detectStateCode();
  }

  detectStateCode() {
    this.isAcmic = this.acmicService.isACMIC();
  }

  resetHideModal(): void {
    this.hideModalOnRoute = !this.hideModalOnRoute;
    this.modalForMultiplePayment = false;
  }

  errorHandlerForNonGuest(error) {
    if (error.status === 500 || error.status === 504) {
      this.router.navigate(['billing', this.policyId, Constants.PAYMENT_CONFIRMATION]);
      this.reload();
    } else if (error.status === 403) {
      if (error.error.message == '05') {
        this.modalForMultiplePayment = true;
      } else if (error.error.message == '01') {
        this.router.navigate(['billing', this.policyId, 'new-payment'], {
          queryParams: { invalidRouting: 'Y' },
        });
      } else {
        this.router.navigate([
          'billing',
          this.policyId,
          'payment-error',
          error.error.message,
        ]);
      }
    } else if (
      error.status === 400 ||
      error.status === 401 ||
      error.status === 404 ||
      error.status === 408
    ) {
      this.alertService.error(
        'There was a problem paying your bill, please review your details'
      );
    } else {
      this.errorRedirectionService.errorRedirectHandler(error, this.policyId);
    }
  }
  errorHandlerForGuest(error) {
    if (error.status === 500 || error.status === 504) {
      this.router.navigate([
        Constants.MAKE_PAYMENT,
        this.policyId,
        Constants.PAYMENT_CONFIRMATION,
      ]);
    } else if (error.status === 403) {
      if (error.error.message == '05') {
        this.modalForMultiplePayment = true;
      } else if (error.error.message == '01') {
        this.router.navigate(
          [Constants.MAKE_PAYMENT, this.policyId, 'new-guest-payment'],
          { queryParams: { invalidRouting: 'Y' } }
        );
        this.alertService.error(
          'Please review and enter a valid routing number'
        );
      } else {
        this.navigateOnError(error);
      }
    } else if (
      error.status === 400 ||
      error.status === 401 ||
      error.status === 404 ||
      error.status === 408
    ) {
      this.navigateOnError(error);
    } else {
      this.errorRedirectionService.errorRedirectHandler(error);
    }
  }
  navigateOnError(error): void {
    this.router.navigate([
      Constants.MAKE_PAYMENT,
      this.policyId,
      'payment-error',
      error.error.message,
    ]);
  }
  payment(billing, multiple = 'N', storeInstrument) {
    if (this.loader) {
      return false;
    }
    this.loader = true;
    this.billingDetailsService
      .makeECheckPayment(
        billing,
        this.email,
        this.policyId,
        multiple,
        storeInstrument,
        this.achBilling
      )
      .subscribe(
        () => {
          this.loader = false;
          this.billingDataService.clearBilling();
          this.billingDataService.updateBankAccountCheck(null);
          if (this.achBilling) {
            this.router.navigate([
              Constants.MAKE_PAYMENT,
              this.policyId,
              Constants.PAYMENT_CONFIRMATION,
            ]);
          } else {
            this.resync();
            this.reload();
            this.router.navigate([
              'billing',
              this.policyId,
              Constants.PAYMENT_CONFIRMATION,
            ]);
            if (Capacitor.isNativePlatform()) {
              this.appRatingService.rateApp();
            }
          }
        },
        (error) => {
          this.loader = false;
          if (!this.achBilling) {
            this.errorHandlerForNonGuest(error);
          } else {
            this.errorHandlerForGuest(error);
          }
        }
      );
  }

  resync() {
    this.userDetailsService.getUserDetailsByEmail().subscribe(() => {
      // do nothig
    });
  }

  saveCheckingAccount(bankAccountDetails): void {
    this.bankAccountService
      .addBankAccount(this.email, bankAccountDetails, this.policyId)
      .subscribe(() => {
        // do nothing
      });
  }

  sendPayment(multiple): void {
    if (this.storeBankAccount) {
      this.payment(this.billing, multiple, 'Y');
      if (this.policyId.length == 6) {
        this.saveCheckingAccount(this.billing.bankAccount);
      }
    } else {
      this.payment(this.billing, multiple, 'N');
    }
  }

  onClickBack() {
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId = params['policyid'] || this.ach_policyId;
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        this.policyDetails = policyResponse;
      });
      this.billingDataService.$billingDetailsEcheck.subscribe((billing) => {
        this.billing = billing;
      });      
    });
    this.billingDataService.$storeBankAccount.subscribe((bankAccountCheck) => {
      this.storeBankAccount = bankAccountCheck;
    });
  }

  goBackToNewPayment() {
    this.router.navigate([Constants.MAKE_PAYMENT_ROUTE, this.policyId, 'new-guest-payment']);
  }
  reload() {
    this.policyDetailsService
      .getPolicyDetailsByEmail(this.storageService.getUserFromStorage())
      .subscribe(() => {
        //do nothing
      });
  }
}
